import { AfterViewInit, Component, computed, ElementRef, inject, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentWrapper } from '../cockpitComponents/ComponentWrapper/component-wrapper.component';
import { ComponentKey, Components } from '../cockpitComponents';
import { CommonModule } from '@angular/common';
import { componentList } from '../cockpitComponents';
import { DesignSidebar } from './disignerSideBar/design.sidebar.component';
import { CdkDragDrop, CdkDropList, DragDropModule } from '@angular/cdk/drag-drop';
import { DropListRegistryService } from './drop-list-registry.service';
import { CockpitDesignerStore } from './cockpitDesigner.service';
import { MOCK_LAYOUT } from './mockCockpitlayout';
import { VideoPlayerComponent } from '../videoPlayer/video-component';
import { signal } from '@angular/core';
import { DevicesService } from '../bots/devices.service';
import { GridComponent } from './cockpitDesigner.models';

export interface gridComponents {
  name: ComponentKey;
  id: string
  componentSettings:  []
}

@Component({
  selector: 'app-cockpit-designer',
  templateUrl: 'cockpitDesigner.component.html',
  styleUrl: 'cockpitDesigner.component.css',
  imports: [CommonModule, DesignSidebar, DragDropModule, ComponentWrapper,VideoPlayerComponent],
  standalone: true,
})
export class CockpitDesigner implements AfterViewInit {
  router = inject(Router);
  private registry = inject(DropListRegistryService);
  @ViewChildren(CdkDropList) cellLists!: QueryList<CdkDropList>;
  @ViewChild('demoVideo')
  demoVideo!: ElementRef<HTMLVideoElement>;
  fakeRemoteStream = signal<MediaStream | null>(null);
  private deviceService = inject(DevicesService);
  readonly devices = this.deviceService.devices()

  cockpitComponentsList = componentList;
  components = Components;
  selectedComponent= signal<{gridComponent:GridComponent, rowId:string, columnId: string} | null>(null);
  store = inject(CockpitDesignerStore);

  async ngAfterViewInit() {
    this.cellLists.forEach((list) => this.registry.register(list));
      const video = this.demoVideo.nativeElement;
    video.muted = true; // important
    video.loop = true;
    video.playsInline = true;
    await video.play()
     if(video) {
      await new Promise(r => setTimeout(r, 500));
      const stream = (video as any ).captureStream() as MediaStream;
       this.fakeRemoteStream.set(stream);
     }  
  }

  getConnectedLists() {
    return this.registry.getAll();
  }

  ngOnInit() {
    this.store.load(MOCK_LAYOUT);
  }

  onPlayerClick(){
    console.log('fake click')
  }
  handleOpenUp(event:GridComponent, rowId:string, columnId:string){
    if(event.id === this.selectedComponent()?.gridComponent.id) {
      this.selectedComponent.set(null);
      this.store.selectedRowId.set(null)
      
      return
    }
    this.store.selectedRowId.set(rowId)
    this.selectedComponent.set({gridComponent:event, rowId, columnId});
  }


  drop(event: CdkDragDrop<any>, targetItem: any) {
    if (event.previousContainer !== event.container) {
      targetItem.id = event.previousContainer.data.type;
    }
  }

  handleRowClick(id:string){

    this.store.selectedRowId.set(id)
  } 

  onAssignedBotsChange(event: string[]){
    this.store.setAssignedDeviceIds(event)
  }

  handleSave = () => this.store.saveLayout();

  onCloseComponentSettings(){
    this.selectedComponent.set(null);
  }

  handlePushButtonIdChange(event: string){
    console.log('made it here push button Id change', event)
  }

  handlePushButtonNameChange(event: string){
    console.log('made it here push button namechange', event)
  }
  componentChange(event: {gridComponent:GridComponent, rowId:string, columnId:string}){
    this.store.updateCockpit(event)
    console.log("made it here in the ockpit designers",event )
  }

  private renderComponents() {}
}
